<template>
  <div>
    <v-alert
      class="my-4"
      type="success"
      dismissible
      v-for="item in betSuccess"
      :key="item.id_bet"
    >
      {{ `Código: ${item.id_bet} - ${item.messages}` }}
    </v-alert>

    <v-alert
      class="my-4"
      type="warning"
      dismissible
      v-for="item in betWarning"
      :key="item.id_bet"
    >
      {{ `Código: ${item.id_bet} - ${item.messages}` }}
    </v-alert>

    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <HeaderPrint />
        <div>
          {{ $t("FilteredPeriod") }}:
          {{ $date.formatRange(rangeDate) }}
        </div>
      </div>
      <!-- end/ PRINT ONLY -->

      <v-card>
        <div class="pa-2 d-print-none">
          <!-- <v-spacer></v-spacer> -->
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                class="white black--text d-print-none mr-2"
                @click="$printReport()"
              >
                <v-icon small left> mdi-printer </v-icon>
                {{ $t("print") }}
              </v-btn>
              <v-btn
                v-if="result === 2"
                depressed
                color="success"
                :disabled="selected.length === 0 || payingBet"
                :loading="payingBet"
                v-on:click="payBet"
              >
                {{ $t("paidBets") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="data"
          item-key="name"
          :show-select="result == 2"
          :search="search"
          class="elevation-1 historic-bet"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" small>
              {{ item.id }}
            </v-btn>
          </template>
          <template v-slot:item.select="{ item }">
            <v-checkbox v-model="item.select"></v-checkbox>
          </template>
          <template v-slot:item.name_user="{ item }">
            <p class="mb-0 caption">
              {{ `${$t("punter")}: ${item.punter}` }}
            </p>
            <p class="mb-0 caption">
              {{ `${$t("agent")}: ${item.name_user}` }}
            </p>
          </template>

          <template v-slot:item.date="{ item }">
            <span class="caption">{{ item.date }}</span>
          </template>

          <template v-slot:item.events="{ item }">
            <template v-if="!$vuetify.breakpoint.smAndDown">
              <div class="py-2">
                <div
                  v-for="(event, index) in item.events"
                  :key="index"
                  class="caption"
                >
                  {{ event.description }} (
                  {{ $infoTable.markets(event.id_market).name_market || "" }}
                  -
                  {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }}
                  - {{ event.factor_event }}) &nbsp;
                  <span
                    class="font-weight-black"
                    v-html="
                      $infoTable.conference(
                        event.result_event,
                        event.status_event
                      )
                    "
                  ></span>
                  <v-chip
                    class="ml-2 font-weight-black"
                    small
                    color="primary"
                    v-if="event.live_event == '1'"
                  >
                    {{ $t("live") }}
                  </v-chip>
                </div>
              </div>
            </template>
            <template v-else>
              {{ item.events.length }}
            </template>
          </template>

          <template v-slot:item.result_bet="{ item }">
            <div
              class="font-weight-black"
              v-html="$infoTable.conference(item.result_bet, item.status_bet)"
            ></div>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn
              fab
              light
              x-small
              class="d-print-none"
              @click="$bet.showBetDialog(item.id, item.printed)"
            >
              <v-icon size="24">mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </template>
          <template
            v-slot:item.infoString="{ item }"
            v-if="true"
            style="display:none;"
          >
            <div v-show="false">{{ item.infoString }}</div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <!-- Resume Perído -->
    <div class="mt-4" v-if="resume.prizeTotal && resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">
              {{ $t("resumeSummary") }}
              <div class="caption">{{ $store.state.rangeUI }}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("value") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("prizePaids") }}</td>
                    <td class="text-right red--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("prizePossibles") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("prizeTotal") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  name: "local-manager-bet-historic",
  components: {
    HeaderPrint,
  },
  data: () => ({
    data: [],
    search: "",
    selected: [],
    betSuccess: [],
    betWarning: [],
    success: [],

    // complementData
    // result: 3,,

    resume: {},
    payingBet: false,
  }),

  async created() {
    // Setup:
    const request = await this.$request.get(
      "/localManager/profile/permissions"
    );
    this.showTabPayment = request.dados.reward_bet;
  },

  computed: {
    // Setup Filters:
    result() {
      return this.$store.state.filters.selectResultBet.result;
    },
    id_agente() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    status() {
      return this.$store.state.filters.selectStatusBet.status;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },

    headers() {
      return [
        // Coluna "Oculta" com string com informações
        {
          text: "",
          value: "infoString",
          align: " d-none",
        },
        // { text: "Valor_some", value: "amount", align: " d-none" },
        { text: this.$t("punter"), value: "punter", align: " d-none" },
        // ui
        { text: this.$t("code"), value: "id" },
        { text: this.$t("info"), value: "name_user" },
        {
          text: this.$t("events"),
          value: "events",
          width: 300,
          align: "d-none",
        },
        { text: this.$t("dateHour"), value: "date" },
        { text: this.$t("value"), value: "amount" },
        { text: this.$t("return"), value: "prize" },
        { text: this.$t("result"), value: "result_bet" },
        { text: this.$t("action"), value: "action" },
      ];
    },
  },

  watch: {
    result(val) {
      if (val == 2) {
        // this.hideColumn(false);
        this.resetPage();
      } else {
        // this.hideColumn(true);
        this.resetPage();
      }
    },
    saveFilters(val) {
      val && this.getBetsList();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
      this.data = [];
      this.resume = {};
    },

    async getBetsList() {
      this.resetPage();

      const body = {
        ...this.rangeDate,
        resultado: this.result,
        id_agente: this.id_agente || "",
        status: this.status,
        tipo: this.eventNumber,
      };
      const request = await this.$request.post("/localManager/bets/list", body);
      this.rowsPerPageItems = request.length;
      this.data = request.length == 0 ? [] : request.dados.apostas;

      for (const item of this.data) {
        this.$set(item, "name", item.id);
        this.$set(
          item,
          "size",
          item.events.length >= 4 ? 4 : item.events.length
        );
        this.$set(item, "select", false);
        this.$set(item, "conference", this.$infoTable.results(item.result_bet));
      }

      this.data = await Promise.all(
        this.handleDate(this.data),
        this.handleInfos(this.data)
      );

      // Build Resume and add value to reducer
      this.resume = this.$resume.resumeBet(this.data);
    },

    async payBet() {
      this.payingBet = true;

      const selected = this.selected.map((bet) => ({ bets: bet.id }));
      const bets = {};

      for (const [i, item] of selected.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);

        for (let j = 0; j < val_odds.length; j++) {
          bets[`${key_odds[j]}[${i + 1}]`] = val_odds[j];
        }
      }

      const request = await this.$request.post(
        "/localManager/bets/paidBets",
        bets
      );
      await this.getBetsList();
      this.betSuccess = request.success;
      this.betWarning = request.error;
      this.selected = [];

      this.payingBet = false;
    },

    // hideColumn(flag) {
    //   this.headers.filter((item) => {
    //     if (flag) {
    //       this.$set(item, "align", " d-none");
    //     } else {
    //       this.$set(item, "align", " d-block");
    //     }
    //   });
    // },
    // Handle 'string' para alguns dados serem encontrados na busca.
    handleInfos(data) {
      return data.map(async (item) => {
        let infoString = `${item.punter} ${item.name_user}`;
        for (const e of item.events) {
          infoString += `${e.description}
          ${this.$infoTable.markets(e.id_market).name_market}
          ${this.$infoTable.outcomes(e.id_outcome).name_outcome}
          ${this.$infoTable.results(item.result_bet)}`;
        }
        Object.assign(item, { infoString });
        return item;
      });
    },
    handleDate(data) {
      return data.map(async (item) => {
        item.date = new Date(item.date.replace(" ", "T")).toLocaleString();
        return item;
      });
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
/* .historic-bet td.v-data-table__mobile-row:nth-child(1), */
.historic-bet td.v-data-table__mobile-row:nth-child(2),
.historic-bet td.v-data-table__mobile-row:nth-child(3),
.v-data-table-header-mobile {
  display: none !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(4) {
  height: 56px !important;
  font-size: 18px;
}
</style>
